<template>
  <nav class="fixed w-screen flex flex-row z-20 px-6 pb-0 pt-3 size-navbar justify-end items-center select-none
    border-b-2 border-gray-300 border-opacity-80 bg-gray-300
    dark:bg-dark-code dark:border-dark-code dark:border-opacity-10"
    :class="{
      'bg-opacity-100 dark:bg-opacity-100': isMenuOpen,
      'bg-opacity-80 dark:bg-opacity-80': !isMenuOpen
    }"
    id="navbar">
    <button class="navbar-toggle navbar-button" @click="onToggleMenu()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
    <ul class="main-nav list-none text-right" id="navbar-menu">
      <li v-for="(value, index) in buttonList" :key="index">
        <button class="navbar-button" @click="selectOption(value)">
          {{ value | lang('navbar') }}
        </button>
      </li>
      <li class="dark:text-gray-100 leading-snug 4k:text-4xl invisible sm:visible">|</li>
      <li>
        <button class="navbar-button" @click="onChangeLang()">
          {{ 'lang' | lang('navbar') }}
        </button>
      </li>
      <li>
      <button class="navbar-button" @click="onChangeMode()">
        {{ 'mode' | lang('navbar') }}
      </button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  methods: {
    selectOption(option) {
      this.$emit('selected', option);
      if (this.isMenuOpen) {
        this.onToggleMenu();
      }
    },
    onChangeLang() {
      localStorage.lang = localStorage.lang === 'es' ? 'en' : 'es';
      document.documentElement.lang = localStorage.lang;
      this.$emit('lang');
    },
    onChangeMode() {
      if (this.isDarkMode) {
        document.documentElement.classList.remove('dark')
      } else {
        document.documentElement.classList.add('dark')
      }
      this.isDarkMode = !this.isDarkMode;
    },
    onToggleMenu() {
      const mainNav = document.getElementById("navbar-menu");
      mainNav.classList.toggle("active");
      this.isMenuOpen = mainNav.classList.value.includes("active");
      this.showMenu();
    },
    showMenu() {
      const navbar = document.getElementById("navbar");
      navbar.style.height = this.isMenuOpen ? '100%' : '5%';
    }
  },
  data() {
    return {
      buttonList: [
        'cover', 'resume', 'experience', 'education', 'code', 'contact'
      ],
      isMenuOpen: false,
      isDarkMode: false,
    };
  },
}
</script>

<style scoped>
.size-navbar {
  height: 5%;
}

.navbar-button {
  @apply mx-4 px-3 self-end focus:outline-none uppercase tracking-widest font-light
  text-gray-700 hover:text-blue-700 dark:hover:text-blue-400 dark:text-gray-500
  text-base hd:text-sm fhd:text-lg 4k:text-4xl;
}

.main-nav {
  display: none;
}

.navbar-toggle {
  position: absolute;
  top: 10px;
}

.active {
  display: block;
}

@media screen and (min-width: 768px) {
  .main-nav {
    display: flex;
  }

  .navbar-toggle {
    display: none;
  }
}

</style>